import { c as _c } from "react/compiler-runtime";
import { CalendarSolid, ChatBubbleLeftRightSolid, Edit, Home, InfoCircle, NavArrowDown, User, WarningSolid } from '@byway/icons';
import { DialogPanel, Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import clsx from 'clsx';
import { format } from 'date-fns';
import { useTranslations } from 'next-intl';
import { useCallback, useMemo, useState } from 'react';
import { DialogTrigger, Button as RAC_Button } from 'react-aria-components';
import { Button } from 'ui';
import { hasFieldErrors } from 'utils';
import { formatSlashedDDMMYYYY, parseDate } from 'utils/DateFormats';
import { BookButton } from '~/components/BookButton';
import MobileFixedDialog from '~/components/Common/MobileFixedDialog';
import { Drawer } from '~/components/Drawer';
import { ContactUsButton } from '~/components/Journey/ContactUsButton';
import { ClosestCity, Dates, Details, JourneyEditForm, TemplateEditForm } from '~/components/Journey/JourneyEditForm';
import { LoyaltyPriceDisplay } from '~/components/Journey/Loyalty';
import { PriceDetails } from '~/components/Journey/PriceBar';
import { PricePerPerson } from '~/components/Journey/PricePerPerson';
import useJourneyData from '~/hooks/useJourneyData';
import { useJourneyEditErrorMessage } from '~/hooks/useJourneyEditErrorMessage';
import { useLoyaltyPricing } from '~/hooks/useLoyaltyPricing';
import { useIsCheckingAvailability, useJourneyEditErrors, useMobileEditPanel } from '~/stores/journeyStore';
import type { JOURNEY_EDIT_ERROR } from '~/types/Journey.types';
import { isJourneyExpired } from '~/utils/dateHelpers/dateHelpers';
import { shouldOfferDeposit } from '~/utils/paymentHelpers/paymentHelpers';
import { Popover } from '../Popover';
import { InfoPopover } from '../Tooltip';
function JourneyEditErrors(t0) {
  const $ = _c(22);
  const {
    journeyEditErrors: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const journeyEditErrors = t2;
  const t = useTranslations();
  const editErrorMessage = useJourneyEditErrorMessage();
  if (journeyEditErrors.length === 0) {
    return null;
  }
  if (journeyEditErrors.includes("UNKNOWN_FAILURE")) {
    let t3;
    if ($[2] !== t) {
      t3 = t("aria.error");
      $[2] = t;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t3) {
      t4 = <div className="flex-none w-5 h-5 mr-2"><WarningSolid ariaLabel={t3} size="large" className="flex-none w-5 h-5 mr-2" /></div>;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t) {
      t5 = t.rich("content.feedback.trip_error_retrieve", {
        link: _temp
      });
      $[6] = t;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== t5) {
      t6 = <span className="text-sm">{t5}</span>;
      $[8] = t5;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
      t7 = <div className="flex flex-col px-4 my-2 text-status-error prose-p:mt-0 prose-a:text-status-error"><div className="flex flex-row mb-2">{t4}{t6}</div></div>;
      $[10] = t4;
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    return t7;
  }
  let t3;
  if ($[13] !== editErrorMessage || $[14] !== journeyEditErrors || $[15] !== t) {
    let t4;
    if ($[17] !== editErrorMessage || $[18] !== t) {
      t4 = (errorMessage, i) => <div key={`JourneyEditError-${i}-${errorMessage}`} className="flex flex-row mb-2">{i === 0 && <div className="flex-none w-5 h-5 mr-2"><WarningSolid ariaLabel={t("aria.error")} size="large" className="flex-none w-5 h-5 mr-2" /></div>}<span className="text-sm">{editErrorMessage(errorMessage)}</span></div>;
      $[17] = editErrorMessage;
      $[18] = t;
      $[19] = t4;
    } else {
      t4 = $[19];
    }
    t3 = journeyEditErrors.map(t4);
    $[13] = editErrorMessage;
    $[14] = journeyEditErrors;
    $[15] = t;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[20] !== t3) {
    t4 = <div className="flex flex-col px-4 my-2 mt-2 text-status-error prose-p:mt-0 prose-a:text-status-error">{t3}</div>;
    $[20] = t3;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return t4;
}
function _temp(chunks) {
  return <a href="/contact" rel="noopener noreferrer" className="font-medium underline">{chunks}</a>;
}
export default function JourneyMobileCTABar(t0) {
  const $ = _c(128);
  let {
    isTemplateTrip: t1,
    isEditable
  } = t0;
  const isTemplateTrip = t1 === undefined ? false : t1;
  const {
    actions,
    details,
    futurePricingTiers,
    isStartDateInPast,
    journeyType,
    price,
    region,
    source,
    items,
    hasSurpriseMeAccommodation,
    isLastMinute,
    user: t2,
    paxCount: travellerCount,
    roomCount,
    expirationDateTime,
    uniqueId,
    bookingInformation
  } = useJourneyData();
  const {
    fastJourney
  } = t2;
  const t = useTranslations();
  const journeyEditErrors = useJourneyEditErrors();
  const {
    hasLoyaltyDiscount
  } = useLoyaltyPricing();
  const closest_city = items[0].type === "Journey" ? items[0].origin : items[0].title;
  const [isPriceDetailsOpen, setIsPriceDetailsOpen] = useState(false);
  const {
    isMobileEditPanelOpen,
    setIsMobileEditPanelOpen,
    mobileEditPanelIndex,
    setMobileEditPanelIndex
  } = useMobileEditPanel();
  const isCheckingTrip = useIsCheckingAvailability();
  const isBlueprintJourney = source.creationSource === "FROM_TEMPLATE" || source.creationSource === "FROM_VIRTUAL_BLUEPRINT_TEMPLATE" || source.creationSource === "FROM_VIRTUAL_BLUEPRINT";
  const isBlueprint = isBlueprintJourney || isTemplateTrip;
  let t3;
  if ($[0] !== source.creationSource) {
    t3 = source.creationSource.includes("PLAYGROUND");
    $[0] = source.creationSource;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const isPlaygroundTrip = t3;
  const isEarliestCheapestDate = details.startDate === futurePricingTiers?.cheapestAvailableDate;
  const minDurationDays = region.minDurationDays ?? details.tripInDays;
  const maxDurationDays = region.maxDurationDays ?? details.tripInDays;
  const isFastOneWay = fastJourney === "yes";
  const isEnquireOnly = process.env.NEXT_PUBLIC_FORCE_ENQUIRY === "true";
  if (isEnquireOnly) {
    isEditable = false;
  }
  let t4;
  if ($[2] !== expirationDateTime || $[3] !== isBlueprint) {
    t4 = isJourneyExpired(expirationDateTime, isBlueprint);
    $[2] = expirationDateTime;
    $[3] = isBlueprint;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const isExpired = t4;
  let t5;
  if ($[5] !== t) {
    t5 = t("journey.continue");
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const bookButtonCopy = t5;
  const isBookDisabled = !!(journeyEditErrors.length || bookingInformation?.bookingStatus === "BOOKED" || bookingInformation?.bookingStatus === "OUTSTANDING" || hasSurpriseMeAccommodation && isLastMinute || isExpired || isCheckingTrip);
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      Journey: JourneyEditForm,
      Template: TemplateEditForm
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const formComponents = t6;
  const EditForm = formComponents[journeyType === "asTemplate" || isBlueprint || isPlaygroundTrip ? "Template" : "Journey"];
  let t7;
  if ($[8] !== setIsMobileEditPanelOpen) {
    t7 = () => setIsMobileEditPanelOpen(false);
    $[8] = setIsMobileEditPanelOpen;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const onClose = t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [["startDate", "endDate", "duration"], ["closest_city"], ["adult_count", "room_count", "child_count", "childAges"]];
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const tabFields = t8;
  let t9;
  if ($[11] !== t) {
    t9 = t("journey.dates");
    $[11] = t;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t) {
    t10 = t("journey.tab_origin");
    $[13] = t;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t) {
    t11 = t("journey.tab_travellers");
    $[15] = t;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11 || $[19] !== t9) {
    t12 = [t9, t10, t11];
    $[17] = t10;
    $[18] = t11;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const tabLabels = t12;
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = (errors, tabIndex) => hasFieldErrors(errors, tabFields[tabIndex]);
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const hasTabError = t13;
  let t14;
  bb0: {
    if (isTemplateTrip) {
      let t15;
      if ($[22] !== details.tripInDays || $[23] !== t) {
        t15 = t("journey.days_count", {
          count: details.tripInDays
        });
        $[22] = details.tripInDays;
        $[23] = t;
        $[24] = t15;
      } else {
        t15 = $[24];
      }
      t14 = t15;
      break bb0;
    }
    let t15;
    if ($[25] !== details.endDate || $[26] !== details.startDate || $[27] !== details.tripInDays) {
      const startDateParsed = parseDate(details.startDate);
      const endDateParsed = parseDate(details.endDate);
      const sameMonth = format(startDateParsed, "MMM yy") === format(endDateParsed, "MMM yy");
      t15 = sameMonth ? `${format(startDateParsed, "d")} - ${format(endDateParsed, "d MMM yy")}  /  ${details.tripInDays} days` : `${format(startDateParsed, "d MMM")} - ${format(endDateParsed, "d MMM yy")}  /  ${details.tripInDays} days`;
      $[25] = details.endDate;
      $[26] = details.startDate;
      $[27] = details.tripInDays;
      $[28] = t15;
    } else {
      t15 = $[28];
    }
    t14 = t15;
  }
  const dateRangeLabel = t14;
  let t15;
  if ($[29] !== details.startDate) {
    t15 = shouldOfferDeposit(parseDate(details.startDate));
    $[29] = details.startDate;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  const offerDeposit = t15;
  const t16 = `Origin: ${closest_city}`;
  let t17;
  if ($[31] !== t16) {
    t17 = {
      icon: Home,
      label: t16
    };
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== dateRangeLabel) {
    t18 = {
      icon: CalendarSolid,
      label: dateRangeLabel
    };
    $[33] = dateRangeLabel;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  const t19 = `${travellerCount}x Traveller${travellerCount !== 1 ? "s" : ""}`;
  let t20;
  if ($[35] !== t19) {
    t20 = {
      icon: User,
      label: t19
    };
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t17 || $[38] !== t18 || $[39] !== t20) {
    t21 = [t17, t18, t20];
    $[37] = t17;
    $[38] = t18;
    $[39] = t20;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  const tripDetails = t21;
  const t22 = isEditable ? "items-end" : "items-center";
  let t23;
  if ($[41] !== t22) {
    t23 = clsx("flex justify-between px-4 py-2 bg-blue-100 shadow-[0_-2px_20px_rgba(61,61,61,0.1)]", t22);
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  const t24 = isTemplateTrip || isEarliestCheapestDate;
  let t25;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = () => setIsPriceDetailsOpen(true);
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== details.tripInDays || $[45] !== hasLoyaltyDiscount || $[46] !== isCheckingTrip || $[47] !== t24) {
    t26 = <JourneyPriceButton isCheckingTrip={isCheckingTrip} tripInDays={details.tripInDays} isFromPrice={t24} hasLoyaltyDiscount={hasLoyaltyDiscount} onOpenPriceDetails={t25} />;
    $[44] = details.tripInDays;
    $[45] = hasLoyaltyDiscount;
    $[46] = isCheckingTrip;
    $[47] = t24;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== isEditable || $[50] !== setIsMobileEditPanelOpen || $[51] !== t) {
    t27 = isEditable && <Button size="tiny" type="secondary" className="self-start" data-ua-click="mobile-edit-button" onClick={() => setIsMobileEditPanelOpen(true)}><span className="mr-1"><Edit decorative={true} isInline={true} /></span>{t("journey.edit")}</Button>;
    $[49] = isEditable;
    $[50] = setIsMobileEditPanelOpen;
    $[51] = t;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  let t28;
  if ($[53] !== t26 || $[54] !== t27) {
    t28 = <div className="flex flex-col justify-between gap-1">{t26}{t27}</div>;
    $[53] = t26;
    $[54] = t27;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  let t29;
  if ($[56] !== setIsMobileEditPanelOpen) {
    t29 = () => setIsMobileEditPanelOpen(true);
    $[56] = setIsMobileEditPanelOpen;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  let t30;
  if ($[58] !== actions || $[59] !== bookButtonCopy || $[60] !== isBookDisabled || $[61] !== isCheckingTrip || $[62] !== isEditable || $[63] !== isStartDateInPast || $[64] !== isTemplateTrip || $[65] !== t29) {
    t30 = <JourneyCtaButtons isTemplateTrip={isTemplateTrip} isEnquireOnly={isEnquireOnly} actions={actions} bookButtonCopy={bookButtonCopy} isStartDateInPast={isStartDateInPast} isBookDisabled={isBookDisabled} isCheckingTrip={isCheckingTrip} isEditable={isEditable} onEdit={t29} />;
    $[58] = actions;
    $[59] = bookButtonCopy;
    $[60] = isBookDisabled;
    $[61] = isCheckingTrip;
    $[62] = isEditable;
    $[63] = isStartDateInPast;
    $[64] = isTemplateTrip;
    $[65] = t29;
    $[66] = t30;
  } else {
    t30 = $[66];
  }
  let t31;
  if ($[67] !== t23 || $[68] !== t28 || $[69] !== t30) {
    t31 = <MobileFixedDialog.Banner><div className={t23}>{t28}{t30}</div></MobileFixedDialog.Banner>;
    $[67] = t23;
    $[68] = t28;
    $[69] = t30;
    $[70] = t31;
  } else {
    t31 = $[70];
  }
  let t32;
  if ($[71] !== t) {
    t32 = t("aria.close");
    $[71] = t;
    $[72] = t32;
  } else {
    t32 = $[72];
  }
  let t33;
  if ($[73] !== t32) {
    t33 = <NavArrowDown ariaLabel={t32} size="large" />;
    $[73] = t32;
    $[74] = t33;
  } else {
    t33 = $[74];
  }
  let t34;
  if ($[75] !== onClose || $[76] !== t33) {
    t34 = <div className="flex justify-center px-3 pb-2 border-b" onClick={onClose}>{t33}</div>;
    $[75] = onClose;
    $[76] = t33;
    $[77] = t34;
  } else {
    t34 = $[77];
  }
  let t35;
  if ($[78] !== closest_city || $[79] !== details.startDate || $[80] !== details.tripInDays || $[81] !== futurePricingTiers?.cheapestAvailableDateUpdated || $[82] !== futurePricingTiers?.pricingTiers?.length || $[83] !== isBlueprint || $[84] !== isCheckingTrip || $[85] !== isEarliestCheapestDate || $[86] !== isFastOneWay || $[87] !== isPlaygroundTrip || $[88] !== isTemplateTrip || $[89] !== journeyEditErrors || $[90] !== maxDurationDays || $[91] !== minDurationDays || $[92] !== mobileEditPanelIndex || $[93] !== setMobileEditPanelIndex || $[94] !== t || $[95] !== tabLabels || $[96] !== travellerCount || $[97] !== uniqueId) {
    t35 = t36 => {
      const {
        handleSubmit,
        isSubmitting,
        errors: errors_0,
        values
      } = t36;
      return <><TabGroup as="div" selectedIndex={mobileEditPanelIndex} onChange={setMobileEditPanelIndex}><TabList className="grid grid-cols-3 px-4 mt-4">{tabLabels.map((label, index) => <Tab key={index} className={t37 => {
              const {
                selected
              } = t37;
              return clsx("border-b-2 py-2 typography-body-1 focus:bg-primary-200 focus:outline-none", hasTabError(errors_0, index) ? selected ? "border-b-status-error" : "border-b-status-error border-b-opacity-20" : selected ? "border-b-primary-500 text-black" : "border-b-neutral-200 text-neutral-600");
            }}>{label}</Tab>)}</TabList><TabPanels className="min-h-[120px]"><TabPanel>{isEarliestCheapestDate && <p className="px-4 mt-4 mb-2 typography-emphasis-2">{t.rich("journey.cheapest_date_found", {
                  cheapestDate: chunks => <><DialogTrigger><RAC_Button><span className="underline cursor-pointer">{chunks}</span></RAC_Button><Popover placement="bottom" variant="contrast"><span>{t("journey.cheapest_date_tooltip", {
                            pax: travellerCount,
                            city: closest_city,
                            nights: details.tripInDays - 1,
                            date: formatSlashedDDMMYYYY(futurePricingTiers?.cheapestAvailableDateUpdated || details.startDate)
                          })}</span></Popover></DialogTrigger>{" "}</>
                })}</p>}{!isTemplateTrip && !isEarliestCheapestDate && <p className="px-4 mt-4 mb-2 typography-emphasis-2">{t("journey.when_to_go")}</p>}<JourneyEditErrors journeyEditErrors={journeyEditErrors} /><Dates simpleDatePicker={isTemplateTrip || isBlueprint || isFastOneWay || isPlaygroundTrip} durationLimiter={{
                minDurationDays,
                maxDurationDays
              }} /></TabPanel><TabPanel><div className="p-4"><p className="mb-4 typography-emphasis-2">{closest_city ? t("journey.departing_from", {
                    city: closest_city
                  }) : t("journey.origin_heading")}</p><JourneyEditErrors journeyEditErrors={journeyEditErrors} /><div><ClosestCity tripId={uniqueId} startDate={values.startDate} /></div></div></TabPanel><TabPanel><div className="p-4"><p className="mb-4 typography-emphasis-2">{t("journey.travellers_heading")}</p><JourneyEditErrors journeyEditErrors={journeyEditErrors} /><Details /></div></TabPanel></TabPanels></TabGroup><div className="flex items-center justify-between p-4">{mobileEditPanelIndex === 0 && isBlueprint && futurePricingTiers?.pricingTiers?.length && <div className="flex pl-4 mb-4 gap-x-3 typography-caption-1"><div className="text-center"><div>£</div><div className="leading-[0]"><span className="inline-block w-1.5 h-1.5 rounded-full border bg-status-low border-neutral-600" /></div></div><div className="text-center"><div>££</div><div className="space-x-0.5 leading-[0]"><span className="inline-block w-1.5 h-1.5 rounded-full border bg-status-mid border-neutral-600" /><span className="inline-block w-1.5 h-1.5 rounded-full border bg-status-mid border-neutral-600" /></div></div><div className="text-center"><div>£££</div><div className="space-x-0.5 leading-[0]"><span className="inline-block w-1.5 h-1.5 rounded-full border bg-status-high border-neutral-600" /><span className="inline-block w-1.5 h-1.5 rounded-full border bg-status-high border-neutral-600" /><span className="inline-block w-1.5 h-1.5 rounded-full border bg-status-high border-neutral-600" /></div></div></div>}<Button data-ua-click="mobile-check-availability" onClick={handleSubmit} loading={isSubmitting || isCheckingTrip} className="ml-auto">{t("journey.check_availability")}</Button></div></>;
    };
    $[78] = closest_city;
    $[79] = details.startDate;
    $[80] = details.tripInDays;
    $[81] = futurePricingTiers?.cheapestAvailableDateUpdated;
    $[82] = futurePricingTiers?.pricingTiers?.length;
    $[83] = isBlueprint;
    $[84] = isCheckingTrip;
    $[85] = isEarliestCheapestDate;
    $[86] = isFastOneWay;
    $[87] = isPlaygroundTrip;
    $[88] = isTemplateTrip;
    $[89] = journeyEditErrors;
    $[90] = maxDurationDays;
    $[91] = minDurationDays;
    $[92] = mobileEditPanelIndex;
    $[93] = setMobileEditPanelIndex;
    $[94] = t;
    $[95] = tabLabels;
    $[96] = travellerCount;
    $[97] = uniqueId;
    $[98] = t35;
  } else {
    t35 = $[98];
  }
  let t36;
  if ($[99] !== EditForm || $[100] !== isTemplateTrip || $[101] !== t35) {
    t36 = <EditForm isPopulated={true} isTemplateTrip={isTemplateTrip}>{t35}</EditForm>;
    $[99] = EditForm;
    $[100] = isTemplateTrip;
    $[101] = t35;
    $[102] = t36;
  } else {
    t36 = $[102];
  }
  let t37;
  if ($[103] !== t34 || $[104] !== t36) {
    t37 = <div className="min-h-screen px-4 text-center"><DialogPanel className="absolute inset-x-0 bottom-0 w-full"><div className="pt-3 bg-white rounded-tr-2xl rounded-tl-2xl relative z-[1]">{t34}{t36}</div></DialogPanel></div>;
    $[103] = t34;
    $[104] = t36;
    $[105] = t37;
  } else {
    t37 = $[105];
  }
  let t38;
  if ($[106] !== isMobileEditPanelOpen || $[107] !== onClose || $[108] !== t37) {
    t38 = <MobileFixedDialog.Dialog open={isMobileEditPanelOpen} onClose={onClose}>{t37}</MobileFixedDialog.Dialog>;
    $[106] = isMobileEditPanelOpen;
    $[107] = onClose;
    $[108] = t37;
    $[109] = t38;
  } else {
    t38 = $[109];
  }
  let t39;
  if ($[110] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = () => setIsPriceDetailsOpen(false);
    $[110] = t39;
  } else {
    t39 = $[110];
  }
  let t40;
  if ($[111] !== t) {
    t40 = t("aria.price_details");
    $[111] = t;
    $[112] = t40;
  } else {
    t40 = $[112];
  }
  let t41;
  if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = () => setIsPriceDetailsOpen(false);
    $[113] = t41;
  } else {
    t41 = $[113];
  }
  let t42;
  if ($[114] !== offerDeposit || $[115] !== price || $[116] !== roomCount || $[117] !== travellerCount || $[118] !== tripDetails) {
    t42 = <PriceDetails paxCount={travellerCount} roomCount={roomCount} price={price} offerDeposit={offerDeposit} labelItem={tripDetails} onClose={t41} />;
    $[114] = offerDeposit;
    $[115] = price;
    $[116] = roomCount;
    $[117] = travellerCount;
    $[118] = tripDetails;
    $[119] = t42;
  } else {
    t42 = $[119];
  }
  let t43;
  if ($[120] !== isPriceDetailsOpen || $[121] !== t40 || $[122] !== t42) {
    t43 = <Drawer isOpen={isPriceDetailsOpen} close={t39} ariaLabel={t40} noHeader={true}>{t42}</Drawer>;
    $[120] = isPriceDetailsOpen;
    $[121] = t40;
    $[122] = t42;
    $[123] = t43;
  } else {
    t43 = $[123];
  }
  let t44;
  if ($[124] !== t31 || $[125] !== t38 || $[126] !== t43) {
    t44 = <MobileFixedDialog className="md:hidden">{t31}{t38}{t43}</MobileFixedDialog>;
    $[124] = t31;
    $[125] = t38;
    $[126] = t43;
    $[127] = t44;
  } else {
    t44 = $[127];
  }
  return t44;
}
type JourneyActions = ReturnType<typeof useJourneyData>['actions'];
function JourneyPriceButton(t0) {
  const $ = _c(27);
  const {
    isCheckingTrip,
    tripInDays,
    isFromPrice,
    hasLoyaltyDiscount,
    onOpenPriceDetails
  } = t0;
  const t = useTranslations();
  if (isCheckingTrip) {
    let t1;
    if ($[0] !== t || $[1] !== tripInDays) {
      t1 = t("journey.days_count", {
        count: tripInDays
      });
      $[0] = t;
      $[1] = tripInDays;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] !== t1) {
      t2 = <div className="pb-6 text-neutral-700 typography-caption-1"><span className="typography-subtitle-1">{t1} </span></div>;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t1;
  if ($[5] !== t) {
    t1 = t("aria.price_details_view");
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t || $[8] !== tripInDays) {
    t2 = t("journey.days_count", {
      count: tripInDays
    });
    $[7] = t;
    $[8] = tripInDays;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t2) {
    t3 = <span className="typography-subtitle-1">{t2} </span>;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== isFromPrice || $[13] !== t) {
    t4 = isFromPrice ? t("journey.price_from") : t("journey.price_for");
    $[12] = isFromPrice;
    $[13] = t;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <br />;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== hasLoyaltyDiscount) {
    t6 = hasLoyaltyDiscount ? <LoyaltyPriceDisplay variant="mobile" /> : <><InfoCircle decorative={true} strokeWidth={2} /><span className="underline typography-subtitle-1"><PricePerPerson /></span></>;
    $[16] = hasLoyaltyDiscount;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span>/person</span>;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6) {
    t8 = <span className="inline-flex items-center gap-1">{t6}{t7}</span>;
    $[19] = t6;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== onOpenPriceDetails || $[22] !== t1 || $[23] !== t3 || $[24] !== t4 || $[25] !== t8) {
    t9 = <button type="button" className="text-left text-neutral-700 typography-caption-1" onClick={onOpenPriceDetails} data-test-id="mobile-price-details-trigger" aria-label={t1}>{t3}{t4}{t5}{t8}</button>;
    $[21] = onOpenPriceDetails;
    $[22] = t1;
    $[23] = t3;
    $[24] = t4;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}
function PrimaryCtaButton(t0) {
  const $ = _c(22);
  const {
    isTemplateTrip,
    isEnquireOnly,
    actions,
    bookButtonCopy,
    isStartDateInPast,
    isBookDisabled,
    isCheckingTrip
  } = t0;
  const t = useTranslations();
  if (isTemplateTrip) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ContactUsButton isCompact={true} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (isEnquireOnly) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <span className="mr-1 pointer-events-none"><ChatBubbleLeftRightSolid decorative={true} isInline={true} size="small" /></span>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== actions.enquireBook || $[3] !== bookButtonCopy) {
      t2 = <Button is="a" data-ua-click="book-button" href={actions.enquireBook} size="small">{t1}{bookButtonCopy}</Button>;
      $[2] = actions.enquireBook;
      $[3] = bookButtonCopy;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  if (isStartDateInPast) {
    let t1;
    if ($[5] !== t) {
      t1 = t("journey.dates_past_aria_label");
      $[5] = t;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    let t2;
    if ($[7] !== t) {
      t2 = t("journey.dates_past");
      $[7] = t;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] !== t1 || $[10] !== t2) {
      t3 = <InfoPopover ariaLabel={t1} placement="top">{t2}</InfoPopover>;
      $[9] = t1;
      $[10] = t2;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    let t4;
    if ($[12] !== bookButtonCopy) {
      t4 = <Button disabled={true} block={true} size="small">{bookButtonCopy}</Button>;
      $[12] = bookButtonCopy;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    let t5;
    if ($[14] !== t3 || $[15] !== t4) {
      t5 = <div className="inline-flex items-center gap-2">{t3}{t4}</div>;
      $[14] = t3;
      $[15] = t4;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    return t5;
  }
  let t1;
  if ($[17] !== actions.book || $[18] !== bookButtonCopy || $[19] !== isBookDisabled || $[20] !== isCheckingTrip) {
    t1 = <BookButton size="small" disabled={isBookDisabled} href={actions.book} loading={isCheckingTrip}>{bookButtonCopy}</BookButton>;
    $[17] = actions.book;
    $[18] = bookButtonCopy;
    $[19] = isBookDisabled;
    $[20] = isCheckingTrip;
    $[21] = t1;
  } else {
    t1 = $[21];
  }
  return t1;
}
function JourneyCtaButtons(t0) {
  const $ = _c(24);
  const {
    isTemplateTrip,
    isEnquireOnly,
    actions,
    bookButtonCopy,
    isStartDateInPast,
    isBookDisabled,
    isCheckingTrip,
    isEditable,
    onEdit
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== actions || $[1] !== isEditable || $[2] !== isEnquireOnly || $[3] !== isTemplateTrip || $[4] !== onEdit || $[5] !== t) {
    t1 = isTemplateTrip && (isEnquireOnly ? <Button is="a" type="primary" data-ua-click="mobile-edit-button" size="small" href={actions.enquireEdit}><span className="mr-1"><ChatBubbleLeftRightSolid decorative={true} isInline={true} size="small" /></span>{t("journey.edit")}</Button> : <Button size="small" type="primary" data-ua-click="mobile-edit-button" onClick={onEdit} disabled={!isEditable}>{t("journey.check_dates")}</Button>);
    $[0] = actions;
    $[1] = isEditable;
    $[2] = isEnquireOnly;
    $[3] = isTemplateTrip;
    $[4] = onEdit;
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== actions || $[8] !== bookButtonCopy || $[9] !== isBookDisabled || $[10] !== isCheckingTrip || $[11] !== isEnquireOnly || $[12] !== isStartDateInPast || $[13] !== isTemplateTrip) {
    t2 = <PrimaryCtaButton isTemplateTrip={isTemplateTrip} isEnquireOnly={isEnquireOnly} actions={actions} bookButtonCopy={bookButtonCopy} isStartDateInPast={isStartDateInPast} isBookDisabled={isBookDisabled} isCheckingTrip={isCheckingTrip} />;
    $[7] = actions;
    $[8] = bookButtonCopy;
    $[9] = isBookDisabled;
    $[10] = isCheckingTrip;
    $[11] = isEnquireOnly;
    $[12] = isStartDateInPast;
    $[13] = isTemplateTrip;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== actions || $[16] !== isEnquireOnly || $[17] !== isTemplateTrip || $[18] !== t) {
    t3 = !isTemplateTrip && (isEnquireOnly ? <Button is="a" type="secondary" data-ua-click="edit-button" size="small" href={actions.enquireEdit}><span className="mr-1"><ChatBubbleLeftRightSolid decorative={true} isInline={true} size="small" /></span>{t("journey.enquire")}</Button> : <ContactUsButton isCompact={true} />);
    $[15] = actions;
    $[16] = isEnquireOnly;
    $[17] = isTemplateTrip;
    $[18] = t;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== t1 || $[21] !== t2 || $[22] !== t3) {
    t4 = <div className="grid grid-cols-1 gap-2">{t1}{t2}{t3}</div>;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  return t4;
}